var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "yxtbiz-rank",
    },
    [
      !Object.keys(_vm.configData).length
        ? _c(
            "div",
            {
              staticClass: "yxtbiz-rank__empty",
              style: { height: _vm.height ? _vm.height + "px" : "auto" },
            },
            [
              _vm.initFlag < 2
                ? _c(
                    "div",
                    [
                      _c(
                        "yxtf-empty",
                        {
                          attrs: {
                            size: "small",
                            "empty-text": _vm.noFindRank
                              ? _vm
                                  .$t("pc_biz_rank_no_find_rank")
                                  .d("榜单不存在")
                              : _vm
                                  .$t("pc_biz_rank_no_server")
                                  .d("哎呀~服务器开小差啦~"),
                          },
                        },
                        [
                          !_vm.noFindRank
                            ? _c(
                                "div",
                                { attrs: { slot: "image" }, slot: "image" },
                                [
                                  _c("yxt-svg", {
                                    attrs: {
                                      "remote-url":
                                        _vm.$staticBaseUrl +
                                        "ufd/3f5568/common/h5/svg/",
                                      "icon-class": "no-server",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          )
        : _c(
            "div",
            [
              _vm.styleType === 1
                ? _c(
                    "one-column",
                    {
                      ref: "rankList",
                      attrs: {
                        height: _vm.height,
                        rankData: _vm.rankData,
                        apiError: _vm.apiError,
                        initFlag: _vm.initFlag,
                      },
                      on: { changeDate: _vm.changeDate },
                    },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "title" }, slot: "title" },
                        [_vm._t("title")],
                        2
                      ),
                    ]
                  )
                : _c(
                    "two-columns",
                    {
                      ref: "rankList",
                      attrs: {
                        height: _vm.height,
                        rankData: _vm.rankData,
                        apiError: _vm.apiError,
                        initFlag: _vm.initFlag,
                      },
                      on: { changeDate: _vm.changeDate },
                    },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "title" }, slot: "title" },
                        [_vm._t("title")],
                        2
                      ),
                    ]
                  ),
            ],
            1
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }